import React from 'react';

import { FlowValues, StepProps, useAutoNavigate } from '@betterment/js-runtime';

import AccountTypeSelection from './AccountTypeSelection';
import { CustomerFlowValues, getStepTitle } from './Controller';

import { Customer } from '../Checking/data';
import { urlBuilder } from '../Shared/urlBuilder';

export interface AccountTypeSelectionStepProps extends StepProps<FlowValues<CustomerFlowValues>> {
  isTenuredCheckingCustomer: boolean;
  isProspectSignupFlow: boolean;
  customer?: Customer | null;
  navigateRouter: ReturnType<typeof useAutoNavigate>;
  handleClose: () => void;
}

const AccountTypeSelectionStep: React.FC<AccountTypeSelectionStepProps> = ({
  isTenuredCheckingCustomer,
  isProspectSignupFlow,
  customer,
  navigateRouter,
  handleClose,
  ...stepProps
}) => {
  const handleIndividualClick = () => {
    if (isTenuredCheckingCustomer) {
      void navigateRouter(urlBuilder.getAppCheckingAccountCreation.absolute());
    } else {
      stepProps.goToNextStep({ accountType: 'individual', stepTitle: getStepTitle('individual') });
    }
  };

  const handleJointClick = () => {
    if (isProspectSignupFlow && customer?.accounts.length === 1) {
      void navigateRouter(urlBuilder.getAppCheckingJointAccounts.absolute({ accountId: customer.accounts[0].id }));
    } else if (isProspectSignupFlow && customer && customer.accounts.length > 1) {
      throw new Error('User with more than one account attempted to go through prospect joint checking flow');
    } else if (isTenuredCheckingCustomer) {
      void navigateRouter(urlBuilder.getAppCheckingJointAccounts.absolute({ createNewAccount: true }));
    } else {
      stepProps.goToNextStep({ accountType: 'joint', stepTitle: getStepTitle('joint') });
    }
  };

  return (
    <AccountTypeSelection
      {...stepProps}
      handleIndividualClick={handleIndividualClick}
      handleJointClick={handleJointClick}
      handleClose={handleClose}
    />
  );
};

export default AccountTypeSelectionStep;
